"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateProductState = exports.requiredAndInvalidProductFieldsByType = exports.getValidSubtypes = exports.ProductFieldDisplayNameToAttributesMap = exports.ProductFieldAttributesToDisplayNameMap = exports.ProductFieldToolTip = void 0;
const lodash_1 = __importDefault(require("lodash"));
const product_1 = require("../sharedTypings/product");
const productSubtypes_1 = require("./productSubtypes");
const { AMOUNT, ATTRIBUTES, BRAND_NAME, CLASSIFICATION, DESCRIPTIONS, DETAILS, DISPLAY_NAME, ECOMMERCE_NAME, EXTERNAL_ID, ID, IMAGES, LINKED_TO, MSRP, NAME, OWNER_ID, OWNER_TYPE, PRICE, PRODUCT_SHORT_CODE, SIZE, SKU, STATUS, SUBTYPE, TPC, TYPE, UPC, UUID, VISIBLE, } = product_1.ProductField;
const { CBD_MG, DOSE_CBD_MG, DOSE_THC_MG, DOSES, EXTRACTION_METHOD, GROSS_WEIGHT, NET_WEIGHT, STRAIN, THC_MG, TOTAL_WEIGHT, TOTAL_CONCENTRATE_WEIGHT, } = product_1.ProductDetailsField;
const { EFFECT, FLAVOR, GENERAL, INGREDIENT, INTERNAL, } = product_1.ProductAttributesField;
const { BEVERAGE, CARTRIDGE, CBD, EDIBLE, EXTRACT, FLOWER, MERCH, MISC, NON_INV, PILL, PLANT, PREROLL, TINCTURE, TOPICAL, } = product_1.ProductType;
exports.ProductFieldToolTip = {
    [AMOUNT]: 'Flower, prerolls and cartridges require an amount such as 500 (mg) or 1 (G) with the unit of measure input in UOM field',
    [ECOMMERCE_NAME]: `Add an alternate menu title, perhaps if you prefer a shorter name.`,
    [TYPE]: `Every product must belong to a product type/category. Any non cannabis items are Merch`,
    [SUBTYPE]: `Add subtypes to faciliate more specific organization of your product collection and items easier to find by the shopper`,
    [CLASSIFICATION]: `Classify your product to enable sorting and searching at the retail level`,
    [product_1.ProductField.UOM]: `Flower, prerolls and cartridges require a unit of measure along with an amount (3.5) Grams or (500) Milligrams`,
    [THC_MG]: `All products should include total mg of THC`,
    [CBD_MG]: `All products should include total mg of CBD`,
    [SIZE]: `Include a package size when needed to differentiate product variants. For example, a "5-Pack" of prerolls or a "Large" T-shirt.`,
    [DOSES]: `Enter number of doses for edibles, beverages, tinctures, and capsules`,
    [DESCRIPTIONS]: `Include a product description to display on retail menus and ordering sites. Idea: describe the product and offer background on the manufacturer.`,
    [NAME]: `The full name of your product`,
    [OWNER_TYPE]: `A product's owner type dictates how it behaves across the Treez ecosytem. Store products are specific to a singular store, an organization product can be shared across stores, and brand products can be linked to via BrandTreez`,
    [SKU]: `Enter the manufacturer's barcode (UPC code), or if not available enter the manufacturer's SKU. This help improves searching and analytics`,
};
exports.ProductFieldAttributesToDisplayNameMap = {
    [AMOUNT]: product_1.ProductAttributesDisplayName.AMOUNT,
    [ATTRIBUTES]: product_1.ProductAttributesDisplayName.ATTRIBUTES,
    [BRAND_NAME]: product_1.ProductAttributesDisplayName.BRAND_NAME,
    [CBD_MG]: product_1.ProductAttributesDisplayName.CBD_MG,
    [CLASSIFICATION]: product_1.ProductAttributesDisplayName.CLASSIFICATION,
    [DESCRIPTIONS]: product_1.ProductAttributesDisplayName.DESCRIPTIONS,
    [DETAILS]: product_1.ProductAttributesDisplayName.DETAILS,
    [DISPLAY_NAME]: product_1.ProductAttributesDisplayName.DISPLAY_NAME,
    [DOSE_CBD_MG]: product_1.ProductAttributesDisplayName.DOSE_CBD_MG,
    [DOSE_THC_MG]: product_1.ProductAttributesDisplayName.DOSE_THC_MG,
    [DOSES]: product_1.ProductAttributesDisplayName.DOSES,
    [ECOMMERCE_NAME]: product_1.ProductAttributesDisplayName.ECOMMERCE_NAME,
    [EFFECT]: product_1.ProductAttributesDisplayName.EFFECT,
    [EXTERNAL_ID]: product_1.ProductAttributesDisplayName.EXTERNAL_ID,
    [EXTRACTION_METHOD]: product_1.ProductAttributesDisplayName.EXTRACTION_METHOD,
    [FLAVOR]: product_1.ProductAttributesDisplayName.FLAVOR,
    [GENERAL]: product_1.ProductAttributesDisplayName.GENERAL,
    [GROSS_WEIGHT]: product_1.ProductAttributesDisplayName.GROSS_WEIGHT,
    [ID]: product_1.ProductAttributesDisplayName.ID,
    [IMAGES]: product_1.ProductAttributesDisplayName.IMAGES,
    [INGREDIENT]: product_1.ProductAttributesDisplayName.INGREDIENT,
    [INTERNAL]: product_1.ProductAttributesDisplayName.INTERNAL,
    [LINKED_TO]: product_1.ProductAttributesDisplayName.LINKED_TO,
    [MSRP]: product_1.ProductAttributesDisplayName.MSRP,
    [NAME]: product_1.ProductAttributesDisplayName.NAME,
    [NET_WEIGHT]: product_1.ProductAttributesDisplayName.NET_WEIGHT,
    [OWNER_ID]: product_1.ProductAttributesDisplayName.OWNER_ID,
    [OWNER_TYPE]: product_1.ProductAttributesDisplayName.OWNER_TYPE,
    [PRICE]: product_1.ProductAttributesDisplayName.PRICE,
    [PRODUCT_SHORT_CODE]: product_1.ProductAttributesDisplayName.PRODUCT_SHORT_CODE,
    [product_1.ProductField.UOM]: product_1.ProductAttributesDisplayName.UOM,
    [SIZE]: product_1.ProductAttributesDisplayName.SIZE,
    [SKU]: product_1.ProductAttributesDisplayName.SKU,
    [STATUS]: product_1.ProductAttributesDisplayName.STATUS,
    [STRAIN]: product_1.ProductAttributesDisplayName.STRAIN,
    [SUBTYPE]: product_1.ProductAttributesDisplayName.SUBTYPE,
    [THC_MG]: product_1.ProductAttributesDisplayName.THC_MG,
    [TOTAL_WEIGHT]: product_1.ProductAttributesDisplayName.TOTAL_WEIGHT,
    [TOTAL_CONCENTRATE_WEIGHT]: product_1.ProductAttributesDisplayName.TOTAL_CONCENTRATE_WEIGHT,
    [TPC]: product_1.ProductAttributesDisplayName.TPC,
    [TYPE]: product_1.ProductAttributesDisplayName.TYPE,
    [UPC]: product_1.ProductAttributesDisplayName.UPC,
    [UUID]: product_1.ProductAttributesDisplayName.UUID,
    [VISIBLE]: product_1.ProductAttributesDisplayName.VISIBLE,
};
exports.ProductFieldDisplayNameToAttributesMap = {
    [product_1.ProductAttributesDisplayName.AMOUNT]: AMOUNT,
    [product_1.ProductAttributesDisplayName.ATTRIBUTES]: ATTRIBUTES,
    [product_1.ProductAttributesDisplayName.BRAND_NAME]: BRAND_NAME,
    [product_1.ProductAttributesDisplayName.CBD_MG]: CBD_MG,
    [product_1.ProductAttributesDisplayName.CLASSIFICATION]: CLASSIFICATION,
    [product_1.ProductAttributesDisplayName.DESCRIPTIONS]: DESCRIPTIONS,
    [product_1.ProductAttributesDisplayName.DETAILS]: DETAILS,
    [product_1.ProductAttributesDisplayName.DISPLAY_NAME]: DISPLAY_NAME,
    [product_1.ProductAttributesDisplayName.DOSE_CBD_MG]: DOSE_CBD_MG,
    [product_1.ProductAttributesDisplayName.DOSE_THC_MG]: DOSE_THC_MG,
    [product_1.ProductAttributesDisplayName.ECOMMERCE_NAME]: ECOMMERCE_NAME,
    [product_1.ProductAttributesDisplayName.EFFECT]: EFFECT,
    [product_1.ProductAttributesDisplayName.EXTERNAL_ID]: EXTERNAL_ID,
    [product_1.ProductAttributesDisplayName.EXTRACTION_METHOD]: EXTRACTION_METHOD,
    [product_1.ProductAttributesDisplayName.FLAVOR]: FLAVOR,
    [product_1.ProductAttributesDisplayName.GENERAL]: GENERAL,
    [product_1.ProductAttributesDisplayName.GROSS_WEIGHT]: GROSS_WEIGHT,
    [product_1.ProductAttributesDisplayName.ID]: ID,
    [product_1.ProductAttributesDisplayName.IMAGES]: IMAGES,
    [product_1.ProductAttributesDisplayName.INGREDIENT]: INGREDIENT,
    [product_1.ProductAttributesDisplayName.INTERNAL]: INTERNAL,
    [product_1.ProductAttributesDisplayName.LINKED_TO]: LINKED_TO,
    [product_1.ProductAttributesDisplayName.MSRP]: MSRP,
    [product_1.ProductAttributesDisplayName.NAME]: NAME,
    [product_1.ProductAttributesDisplayName.NET_WEIGHT]: NET_WEIGHT,
    [product_1.ProductAttributesDisplayName.OWNER_ID]: OWNER_ID,
    [product_1.ProductAttributesDisplayName.OWNER_TYPE]: OWNER_TYPE,
    [product_1.ProductAttributesDisplayName.PRICE]: PRICE,
    [product_1.ProductAttributesDisplayName.PRODUCT_SHORT_CODE]: PRODUCT_SHORT_CODE,
    [product_1.ProductAttributesDisplayName.SIZE]: SIZE,
    [product_1.ProductAttributesDisplayName.SKU]: SKU,
    [product_1.ProductAttributesDisplayName.STATUS]: STATUS,
    [product_1.ProductAttributesDisplayName.STRAIN]: STRAIN,
    [product_1.ProductAttributesDisplayName.SUBTYPE]: SUBTYPE,
    [product_1.ProductAttributesDisplayName.THC_MG]: THC_MG,
    [product_1.ProductAttributesDisplayName.TOTAL_WEIGHT]: TOTAL_WEIGHT,
    [product_1.ProductAttributesDisplayName.TOTAL_CONCENTRATE_WEIGHT]: TOTAL_CONCENTRATE_WEIGHT,
    [product_1.ProductAttributesDisplayName.TPC]: TPC,
    [product_1.ProductAttributesDisplayName.TYPE]: TYPE,
    [product_1.ProductAttributesDisplayName.UOM]: product_1.ProductField.UOM,
    [product_1.ProductAttributesDisplayName.UPC]: UPC,
    [product_1.ProductAttributesDisplayName.UUID]: UUID,
    [product_1.ProductAttributesDisplayName.VISIBLE]: VISIBLE,
};
exports.getValidSubtypes = (productType) => {
    switch (productType) {
        case BEVERAGE:
            return productSubtypes_1.beverageSubtypes;
        case CARTRIDGE:
            return productSubtypes_1.cartridgeSubtypes;
        case CBD:
            return productSubtypes_1.cbdSubtypes;
        case EDIBLE:
            return productSubtypes_1.edibleSubtypes;
        case EXTRACT:
            return productSubtypes_1.extractSubtypes;
        case FLOWER:
            return productSubtypes_1.flowerSubtypes;
        case MERCH:
            return productSubtypes_1.merchSubtypes;
        case MISC:
            return productSubtypes_1.miscSubtypes;
        case NON_INV:
            return productSubtypes_1.nonInvSubtypes;
        case PILL:
            return productSubtypes_1.pillSubtypes;
        case PLANT:
            return productSubtypes_1.plantSubtypes;
        case PREROLL:
            return productSubtypes_1.prerollSubtypes;
        case TINCTURE:
            return productSubtypes_1.tinctureSubtypes;
        case TOPICAL:
            return productSubtypes_1.topicalSubtypes;
        default:
            return productSubtypes_1.allSubtypes;
    }
};
const universallyRequiredFields = [
    NAME,
    TYPE,
];
const requiredAndInvalidProductFieldsBySubtype = (type, subtype) => {
    switch (type) {
        case PLANT:
            if (subtype === 'SEEDS') {
                return ({
                    required: [
                        ...universallyRequiredFields,
                        SUBTYPE,
                    ],
                    invalid: [
                        THC_MG,
                        EXTRACTION_METHOD,
                        CBD_MG,
                        DOSES,
                        DOSE_THC_MG,
                        TOTAL_WEIGHT,
                        TOTAL_CONCENTRATE_WEIGHT,
                    ]
                });
            }
            else {
                return ({
                    required: [
                        ...universallyRequiredFields,
                        SUBTYPE,
                    ],
                    invalid: [
                        AMOUNT,
                        CBD_MG,
                        DOSE_THC_MG,
                        DOSES,
                        EXTRACTION_METHOD,
                        product_1.ProductField.UOM,
                        THC_MG,
                        TOTAL_WEIGHT,
                    ]
                });
            }
        case PREROLL:
            if (subtype === 'INFUSED') {
                return ({
                    required: [
                        ...universallyRequiredFields,
                        AMOUNT,
                        product_1.ProductField.UOM,
                        SUBTYPE,
                    ],
                    invalid: [
                        CBD_MG,
                        DOSE_CBD_MG,
                        DOSE_THC_MG,
                        DOSES,
                        EXTRACTION_METHOD,
                        GROSS_WEIGHT,
                        NET_WEIGHT,
                    ]
                });
            }
            else {
                return ({
                    required: [
                        ...universallyRequiredFields,
                        AMOUNT,
                        product_1.ProductField.UOM,
                        SUBTYPE,
                    ],
                    invalid: [
                        CBD_MG,
                        DOSES,
                        EXTRACTION_METHOD,
                        THC_MG,
                        TOTAL_CONCENTRATE_WEIGHT
                    ]
                });
            }
        case FLOWER:
            if (subtype === 'INFUSED') {
                return ({
                    required: [
                        ...universallyRequiredFields,
                        AMOUNT,
                        product_1.ProductField.UOM,
                        SUBTYPE,
                    ],
                    invalid: [
                        CBD_MG,
                        DOSE_CBD_MG,
                        DOSE_THC_MG,
                        DOSES,
                        EXTRACTION_METHOD,
                        GROSS_WEIGHT,
                        NET_WEIGHT,
                    ]
                });
            }
            else {
                return ({
                    required: [
                        ...universallyRequiredFields,
                        product_1.ProductField.UOM,
                        SUBTYPE,
                        AMOUNT,
                    ],
                    invalid: [
                        CBD_MG,
                        DOSE_CBD_MG,
                        DOSE_THC_MG,
                        DOSES,
                        EXTRACTION_METHOD,
                        SIZE,
                        THC_MG,
                        TOTAL_WEIGHT,
                        TOTAL_CONCENTRATE_WEIGHT
                    ],
                });
            }
        default: {
            return {
                required: [],
                invalid: [],
            };
        }
    }
};
exports.requiredAndInvalidProductFieldsByType = (type, subtype) => {
    const validationDefinition = {
        [BEVERAGE]: {
            required: [
                ...universallyRequiredFields,
                THC_MG,
            ],
            invalid: [
                EXTRACTION_METHOD,
                TOTAL_CONCENTRATE_WEIGHT
            ],
        },
        [CARTRIDGE]: {
            required: [
                ...universallyRequiredFields,
                AMOUNT,
                product_1.ProductField.UOM,
            ],
            invalid: [
                DOSES,
                DOSE_CBD_MG,
                DOSE_THC_MG,
                SIZE,
                TOTAL_CONCENTRATE_WEIGHT
            ]
        },
        [CBD]: {
            required: [
                ...universallyRequiredFields,
            ],
            invalid: [
                EXTRACTION_METHOD,
                GROSS_WEIGHT,
                NET_WEIGHT,
                STRAIN,
                THC_MG,
                TOTAL_WEIGHT,
                TOTAL_CONCENTRATE_WEIGHT
            ],
        },
        [EDIBLE]: {
            required: [
                ...universallyRequiredFields,
                THC_MG,
            ],
            invalid: [
                EXTRACTION_METHOD,
                TOTAL_CONCENTRATE_WEIGHT
            ],
        },
        [EXTRACT]: {
            required: [
                ...universallyRequiredFields,
                AMOUNT,
                product_1.ProductField.UOM,
            ],
            invalid: [
                DOSES,
                DOSE_CBD_MG,
                DOSE_THC_MG,
                SIZE,
                TOTAL_CONCENTRATE_WEIGHT
            ],
        },
        [FLOWER]: requiredAndInvalidProductFieldsBySubtype(FLOWER, subtype),
        [MERCH]: {
            required: [
                ...universallyRequiredFields,
            ],
            invalid: [
                AMOUNT,
                CBD_MG,
                CLASSIFICATION,
                DOSE_CBD_MG,
                DOSE_THC_MG,
                DOSES,
                EXTRACTION_METHOD,
                GROSS_WEIGHT,
                NET_WEIGHT,
                product_1.ProductField.UOM,
                STRAIN,
                THC_MG,
                TOTAL_WEIGHT,
                TOTAL_CONCENTRATE_WEIGHT
            ],
        },
        [MISC]: {
            required: [
                ...universallyRequiredFields,
                THC_MG,
            ],
            invalid: [
                EXTRACTION_METHOD,
                TOTAL_WEIGHT,
                STRAIN,
                TOTAL_CONCENTRATE_WEIGHT
            ]
        },
        [NON_INV]: {
            required: [
                ...universallyRequiredFields,
            ],
            invalid: [
                AMOUNT,
                CBD_MG,
                CLASSIFICATION,
                DOSE_CBD_MG,
                DOSE_THC_MG,
                DOSES,
                EXTRACTION_METHOD,
                product_1.ProductField.UOM,
                STRAIN,
                THC_MG,
                TOTAL_WEIGHT,
                TOTAL_CONCENTRATE_WEIGHT
            ],
        },
        [PILL]: {
            required: [
                ...universallyRequiredFields,
                THC_MG,
            ],
            invalid: [
                EXTRACTION_METHOD,
                TOTAL_CONCENTRATE_WEIGHT
            ],
        },
        [PLANT]: requiredAndInvalidProductFieldsBySubtype(PLANT, subtype),
        [PREROLL]: requiredAndInvalidProductFieldsBySubtype(PREROLL, subtype),
        [TINCTURE]: {
            required: [
                ...universallyRequiredFields,
                THC_MG,
            ],
            invalid: [
                EXTRACTION_METHOD,
                CBD_MG,
                DOSES,
                TOTAL_CONCENTRATE_WEIGHT
            ],
        },
        [TOPICAL]: {
            required: [
                ...universallyRequiredFields,
                THC_MG,
            ],
            invalid: [
                EXTRACTION_METHOD,
                TOTAL_CONCENTRATE_WEIGHT
            ],
        }
    };
    return validationDefinition[type];
};
exports.updateProductState = (field, value, existingProduct) => {
    const noValueGiven = value == null || value == '';
    if (field === product_1.ProductField.DESCRIPTIONS) {
        return Object.assign(Object.assign({}, existingProduct), { descriptions: {
                main: value,
            } });
    }
    else if (lodash_1.default.includes(product_1.ProductDetailsField, field)) {
        const existingDetails = lodash_1.default.get(existingProduct, 'details', {});
        if (noValueGiven) {
            return Object.assign(Object.assign({}, existingProduct), { details: Object.assign({}, lodash_1.default.omit(existingDetails, [field])) });
        }
        else {
            return Object.assign(Object.assign({}, existingProduct), { details: Object.assign(Object.assign({}, existingDetails), { [field]: value }) });
        }
    }
    else if (lodash_1.default.includes(product_1.ProductAttributesField, field)) {
        const existingAttributes = lodash_1.default.get(existingProduct, 'attributes', {});
        if (noValueGiven) {
            return Object.assign(Object.assign({}, existingProduct), { attributes: Object.assign({}, lodash_1.default.omit(existingAttributes, [field])) });
        }
        else {
            return Object.assign(Object.assign({}, existingProduct), { attributes: Object.assign(Object.assign({}, existingAttributes), { [field]: value }) });
        }
    }
    else {
        if (noValueGiven) {
            return Object.assign({}, lodash_1.default.omit(existingProduct, [field]));
        }
        else {
            return Object.assign(Object.assign({}, existingProduct), { [field]: value });
        }
    }
};
//# sourceMappingURL=data:application/json;base64,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